import { useLocation, useNavigate } from 'react-router-dom'

import { Tabs } from '@factorialco/deprecated-design-system'

import { useEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'

import {
  useMatchPaymentUrl,
  useMatchResultUrl,
  useMatchSupplementsUrl,
} from 'modules/payroll_bundle/hooks/useMatchPayrollUrls'
import type { Tab } from 'modules/payroll_bundle/lib/types'

interface Props {
  tabs: Tab[]
  policyId?: string | number
  periodId?: string | number
  isOffcycle: boolean
}

const NavigationTabs = ({ tabs, policyId, periodId, isOffcycle }: Props) => {
  const { pathname } = useLocation()
  const isPaymentPage = useMatchPaymentUrl(policyId, periodId)
  const isResultPage = useMatchResultUrl(policyId, periodId)
  const isSupplementsPage = useMatchSupplementsUrl(policyId, periodId)
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  useEffect(() => {
    if (policyId && periodId) {
      let path = null
      if (!isOffcycle) {
        if (isPaymentPage)
          path = navigation.payrollBundle.policy.period.cycles.payments.fullPath({
            policyId,
            periodId,
          })
        if (isResultPage)
          path = navigation.payrollBundle.policy.period.cycles.results.fullPath({
            policyId,
            periodId,
          })
        if (isSupplementsPage)
          path = navigation.payrollBundle.policy.period.cycles.supplements.fullPath({
            policyId,
            periodId,
          })
      } else {
        if (isPaymentPage)
          path = navigation.payrollBundle.policy.period.offcycles.payments.fullPath({
            policyId,
            periodId,
          })
        if (isResultPage)
          path = navigation.payrollBundle.policy.period.offcycles.results.fullPath({
            policyId,
            periodId,
          })
      }

      if (path) navigate(path)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [policyId, periodId])

  if (tabs.length < 2) return null

  return (
    <Tabs currentId={pathname} onTabClicked={(tabId) => navigate(tabId)} hasAdditionalPadding>
      {tabs.map((tab, index) => (
        <Tabs.Tab key={index} id={tab.href} label={tab.name} isActive={tab.href === pathname} />
      ))}
    </Tabs>
  )
}

export default NavigationTabs
